export var setAddressProps = function setAddressProps(address, type) {
  var addressTypes = {
    'delivery': {
      'address1': 'shippingStreetAddress',
      'address2': 'shippingStreetAddress2',
      'state': 'shippingStreetState',
      'city': 'shippingCity',
      'zipCode': 'shippingZip'
    },
    'shipping': {
      'address1': 'shippingStreetAddress',
      'address2': 'shippingStreetAddress2',
      'state': 'shippingStreetState',
      'city': 'shippingCity',
      'zipCode': 'shippingZip'
    },
    'billing': {
      'address1': 'billingStreetAddress',
      'address2': 'billingStreetAddress2',
      'state': 'billingState',
      'city': 'billingCity',
      'zipCode': 'billingZip'
    }
  };
  return addressTypes[type];
};